var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cdetchitolaw"},[_c('sub-title',{attrs:{"text":"诚邀话题解答律师"}}),_c('div',{staticClass:"hualist"},_vm._l((3),function(item,index){return _c('chitolawitem',{key:index,staticClass:"huaitem"})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }